import { autoinject } from "aurelia-framework";
import { UserManager } from "oidc-client-ts";
import { Router } from "aurelia-router";
import { OriginService } from "./origin-service";
import { ExternalAuthService } from "./external-auth-service";

const returnUrlKey: string = "returnUrlAfterSignIn";

@autoinject
export class OidcService {
  private readonly _router: Router;
  private readonly _userManager: UserManager;
  private readonly _originService: OriginService;
  private readonly _externalAuthService: ExternalAuthService;

  public constructor(
    userManager: UserManager,
    router: Router,
    originService: OriginService,
    externalAuthService: ExternalAuthService
  ) {
    this._userManager = userManager;
    this._router = router;
    this._originService = originService;
    this._externalAuthService = externalAuthService;
  }

  public async getUser() {
    return await this._userManager.getUser();
  }

  public async getSession() {
    return await this._userManager.querySessionStatus();
  }

  public async logout() {
    this._originService.clear();
    this._externalAuthService.clear();
    await this._userManager.clearStaleState();
    await this._userManager.signoutRedirect();
  }

  public async redirectForSignIn() {
    await this._userManager.clearStaleState();
    let returnUrl = `${window.location.pathname}${window.location.search}`;
    this.setReturnUrl(returnUrl);
    await this._userManager.signinRedirect();
  }

  public async navigateToReturnUrl() {
    await this._userManager.signinRedirectCallback(window.location.toString());
    let returnUrl = this.getReturnUrl();

    // we don't want the return url to be /signin-oidc
    if (returnUrl && !returnUrl.toLowerCase().startsWith("/signin-oidc")) {
      this._router.navigate(returnUrl);
    } else {
      this._router.navigate("/profile");
    }
  }

  private getReturnUrl() {
    return window.sessionStorage.getItem(returnUrlKey);
  }

  private setReturnUrl(returnUrl: string) {
    window.sessionStorage.setItem(returnUrlKey, returnUrl);
  }
}
